import type { LangCode } from '../../../types';

export function getSuggestedLanguage(): LangCode {
  const navLang = (navigator.language || 'en').toLowerCase().replace('_', '-');

  if (navLang.startsWith('zh')) {
    if (navLang.includes('tw') || navLang.includes('hk') || navLang.includes('mo') || navLang.includes('hant')) {
      return 'zh-hant' as LangCode;
    }
    return 'zh-hans' as LangCode;
  }

  if (navLang === 'pt-br') {
    return 'pt-br' as LangCode;
  }

  return navLang.substr(0, 2) as LangCode;
}
